// FeedbackLoop engine — section-by-section client feedback with approval stamps.

export interface FeedbackComment {
  id: string;
  author: string;
  body: string;
  createdISO: string;
  resolved: boolean;
}

export interface ReviewSection {
  id: string;
  title: string;
  content: string;
  status: 'pending' | 'approved' | 'change_requested';
  approvedBy?: string;
  approvedISO?: string;
  comments: FeedbackComment[];
}

export interface ReviewRound {
  id: string;
  projectName: string;
  client: string;
  reviewer: string;
  versionLabel: string;
  createdISO: string;
  sections: ReviewSection[];
  status: 'open' | 'completed';
}

export function emptyRound(): ReviewRound {
  return {
    id: crypto.randomUUID(),
    projectName: '', client: '', reviewer: '',
    versionLabel: 'v1.0',
    createdISO: new Date().toISOString(),
    sections: [],
    status: 'open',
  };
}

export function roundCompletion(r: ReviewRound): { approved: number; total: number; percent: number; allApproved: boolean } {
  const total = r.sections.length;
  const approved = r.sections.filter(s => s.status === 'approved').length;
  return { approved, total, percent: total ? (approved / total) * 100 : 0, allApproved: total > 0 && approved === total };
}

export function auditTrail(r: ReviewRound): string {
  const lines: string[] = [`# Audit trail — ${r.projectName} ${r.versionLabel}`, `Reviewer: ${r.reviewer} · Created: ${r.createdISO.slice(0,16).replace('T', ' ')}`, ''];
  r.sections.forEach((s, ix) => {
    lines.push(`## ${ix + 1}. ${s.title} — ${s.status.toUpperCase()}`);
    if (s.approvedBy) lines.push(`Approved by ${s.approvedBy} at ${s.approvedISO?.slice(0,16).replace('T', ' ')}`);
    if (s.comments.length) {
      lines.push('');
      lines.push('**Comments:**');
      s.comments.forEach(c => { lines.push(`- _${c.author} · ${c.createdISO.slice(0,16).replace('T', ' ')}${c.resolved ? ' · ✓ resolved' : ''}_  ${c.body}`); });
    }
    lines.push('');
  });
  return lines.join('\n');
}

export function shareableLink(r: ReviewRound): string {
  return `${window.location.origin}${window.location.pathname}#round=${r.id}`;
}
